<app-file-upload-modal-layout
  [isUploadButtonBusy]="isUploadButtonBusy()"
  [isUploadButtonDisabled]="isUploadButtonDisabled()"
  [isCancelButtonDisabled]="isCancelButtonDisabled()"
  [isCloseIconDisabled]="isCloseIconDisabled()"
  [isFileUploading]="fileUploading"
  (actionButtonClick)="onButtonClick($event)"
  (closeIconClick)="onCloseIconClick()"
>
  <div class="file-upload-modal__left-section file-upload-modal__file-details">
    <div class="file-upload-modal__file-details-label">
      <span class="file-upload-modal__file-details-label-text">Upload File</span>
    </div>

    <div class="file-upload-modal__drag-and-drop-container">
      <app-drag-and-drop-file
        [invalidFiles]="isUploadedFileInvalid()"
        [fileName]="selectedFile?.name"
        (clearFiles)="clearFile()"
        (filesChange)="onFileSelect($event)"
      >
      </app-drag-and-drop-file>
    </div>
  </div>

  <div class="file-upload-modal__right-section file-upload-modal__requirements">
    <span class="file-upload-modal__requirements-title">Upload requirements</span>
    <span>Max file size is 100MB.</span>
    <span *ngIf="fileValidationMessage" class="file-upload-modal__requirements-warning-message">
      {{ fileValidationMessage }}
    </span>
  </div>
</app-file-upload-modal-layout>
